export default (state, { payload: { focus } }) => ({
  ...state,
  sortFocus: focus
});
